import './calendar.scss';

export default function CalendarComponent() {
    const $calendars = document.querySelectorAll('.calendar');
    let tenderNoticeList = document.querySelector('[data-tender-notice]') as HTMLScriptElement;

    if ($calendars.length) {
        $calendars.forEach(($calendar) => {
            tenderNoticeList = JSON.parse(tenderNoticeList.innerHTML);
            const $noticeWrapper = $calendar.querySelector('.tender-notice-wrapper') as HTMLDivElement;
            const $noResults = $calendar.querySelector('.no-results') as HTMLDivElement;
            const $tableBody = $calendar.querySelector('tbody') as HTMLTableSectionElement;
            const $btnPrev = $calendar.querySelector('.btn.prev') as HTMLButtonElement;
            const $btnNext = $calendar.querySelector('.btn.next') as HTMLButtonElement;
            const $popUp = $calendar.querySelector('.pop-up') as HTMLDivElement;
            const currentDate = new Date();
            let months: Object[] = [];
            let monthOffset = 0;
            const colors = [
                "#9ca2cc",
                "#6362ae",
                "#25e551",
                "#1f6ac6",
                "#38d353",
                "#f32b36",
                "#6aa792",
                "#af5fb3",
                "#d84183",
                "#f7e3dc",
                "#c8b257",
                "#b5bf04",
                "#bc9418",
                "#d61b74",
                "#49443b",
                "#b0d797",
                "#20edef",
                "#240015",
                "#41d2ce",
                "#3e6b2a",
                "#2d10b0",
                "#2d45c4",
                "#6aa28e",
                "#e1e844",
                "#54a711",
                "#78b44f",
                "#882dd2",
                "#6456ea",
                "#a1e6d5",
                "#f65e01",
                "#a310fd",
                "#c7b2d4",
                "#81a769",
                "#33c830",
                "#cd941c",
                "#70f260",
                "#c22812",
                "#da5483",
                "#43ccdc",
                "#2086c9",
                "#61c8fb",
                "#bfcd3d",
                "#e3a84b",
                "#9349bf",
                "#293612",
                "#1d764d",
                "#7fd31e",
                "#423dc1",
                "#f260cc",
                "#b1a0d1"
            ];
            const mediaQuery = matchMedia("(max-width: 768px)");

            if(tenderNoticeList) {
                Object.values(tenderNoticeList).forEach((item: any, index) => {
                    item.color = colors[index];
                })

                function getMonth(date: Date) {
                    return date.toLocaleString("it-IT", {
                        month: "long",
                        year: "numeric"
                    });
                }

                function createMonth(date: Date) {
                    const month = document.createElement('th');
                    month.setAttribute('scope', 'col');
                    month.classList.add('col-title');
                    month.innerHTML = getMonth(date);
                    return month;
                }

                function updateCalendar() {
                    $noticeWrapper.innerHTML = '';
                    $tableBody.innerHTML = '';
                    months = [];
                    generateMonths();
                    const activeTenders = getActiveTenders();
                    if(activeTenders.length > 0) {
                        addTenderNoticeToCalendar(activeTenders);
                        if(!$noResults.classList.contains('d-none')) {
                            $noResults.classList.add('d-none');
                            $noticeWrapper.classList.remove('no-res');
                        }
                    } else {
                        $noResults.classList.remove('d-none');
                        $noticeWrapper.classList.add('no-res');
                    }
                }

                function generateMonths() {
                    const startDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + monthOffset, 1);
                    if (mediaQuery.matches) {
                        Array.from({ length: 3 }).forEach((_, i) => {
                            const monthDate = new Date(startDate.getFullYear(), startDate.getMonth() + i, 1);
                            months.push(createMonth(monthDate));
                        });
                        $btnNext.removeAttribute('disabled');
                        if(monthOffset === 3) {
                            $btnNext.setAttribute('disabled', '');
                        }
                    } else {
                        Array.from({ length: 6 }).forEach((_, i) => {
                            const monthDate = new Date(startDate.getFullYear(), startDate.getMonth() + i, 1);
                            months.push(createMonth(monthDate));
                            const date = new Date(currentDate.getFullYear(), currentDate.getMonth() - 6, 1);

                            if((months[0] as HTMLElement).innerHTML !== currentDate.toLocaleDateString('it-IT', {
                                month: "long",
                                year: "numeric",
                            }) && (months[0] as HTMLElement).innerHTML !== date.toLocaleDateString('it-IT', {
                                month: "long",
                                year: "numeric",
                            })) {
                                window.location.reload();
                            }
                        });
                        if(monthOffset === 0) {
                            $btnNext.setAttribute('disabled', '');
                        }
                    }

                    addMonthsToCalendar();
                }

                function addMonthsToCalendar() {
                    const th = document.createElement('th');
                    th.setAttribute('scope', 'col');
                    th.classList.add('col-title');
                    th.innerHTML = `${$noticeWrapper.getAttribute('data-title')}`;
                    $noticeWrapper.appendChild(th);

                    months.forEach((month: any) => {
                        $noticeWrapper.appendChild(month);
                    });
                }

                function sortTenders(number: number) {
                    const startCalendarDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + monthOffset, 1);
                    const endCalendarDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + monthOffset + number, 1);
                    endCalendarDate.setMonth(endCalendarDate.getMonth() + 1);

                    let sortedNoticeList = Object.values(tenderNoticeList).sort((a: any, b: any) => new Date(a.field_start_date[0].value).getTime() - new Date(b.field_start_date[0].value).getTime());
                    return sortedNoticeList.filter((notice: any) => {
                        const startDate = new Date(notice.field_start_date[0].value);
                        const endDate = new Date(notice.field_end_date[0].value);

                        return startDate <= endCalendarDate && endDate >= startCalendarDate;
                    });
                }

                function getActiveTenders() {
                    if(window.innerWidth <= 768) {
                        return sortTenders(2);
                    } else {
                        return sortTenders(5);
                    }
                }

                function addTenderNoticeToCalendar(activeTenders: any) {
                    const $monthElements = Array.from($noticeWrapper.querySelectorAll('th.col-title'));
                    const monthsData = $monthElements.slice(1).map(th => th.textContent?.trim().toLowerCase());

                    const monthMap: Record<string, number> = {
                        "gennaio": 0,
                        "febbraio": 1,
                        "marzo": 2,
                        "aprile": 3,
                        "maggio": 4,
                        "giugno": 5,
                        "luglio": 6,
                        "agosto": 7,
                        "settembre": 8,
                        "ottobre": 9,
                        "novembre": 10,
                        "dicembre": 11
                    };

                    const startMonthYear = (monthsData[0]?.split(' ') ?? []) as string[];
                    const endMonthYear = (monthsData[monthsData.length - 1]?.split(' ') ?? []) as string[];
                    const startMonth = monthMap[startMonthYear[0]];
                    const startYear = parseInt(startMonthYear[1]);
                    const endMonth = monthMap[endMonthYear[0]];
                    const endYear = parseInt(endMonthYear[1]);

                    const viewStartDate = new Date(startYear, startMonth, 1);
                    const viewEndDate = new Date(endYear, endMonth, 31);

                    activeTenders.forEach((notice: any) => {
                        const startDate = new Date(notice.field_start_date[0].value);
                        const endDate = new Date(notice.field_end_date[0].value);

                        const tr = document.createElement('tr');
                        const th = document.createElement('th');
                        const title = document.createElement('a');
                        title.setAttribute('href', notice.metatag.value.canonical_url);
                        title.setAttribute('title', `${notice.title[0].value}`);
                        title.classList.add('notice-title');
                        title.innerHTML = notice.title[0].value;
                        const flag = document.createElement('span');
                        flag.style.borderColor = notice.color;

                        th.appendChild(flag);
                        th.appendChild(title);
                        tr.appendChild(th);

                        Array.from(monthsData).forEach((monthText: any, index: number) => {
                            const td = document.createElement('td');
                            const currentMonth = (new Date(viewStartDate).getMonth() + index) % 12;
                            const currentYear = new Date(viewStartDate).getFullYear() + Math.floor((new Date(viewStartDate).getMonth() + index) / 12);

                            if (currentMonth === new Date().getMonth() && currentYear === new Date().getFullYear()) {
                                td.classList.add('current-month');
                            }

                            const isActive =
                                (startDate <= viewEndDate && endDate >= viewStartDate) &&
                                (startDate.getFullYear() < currentYear || (startDate.getFullYear() === currentYear && startDate.getMonth() <= currentMonth)) &&
                                (endDate.getFullYear() > currentYear || (endDate.getFullYear() === currentYear && endDate.getMonth() >= currentMonth));

                            if (isActive) {
                                td.classList.add('active');
                                td.setAttribute('date', monthText);

                                if (td.getAttribute('date') === startDate.toLocaleString('it-IT', {
                                    month: 'long',
                                    year: 'numeric'
                                })) {
                                    td.classList.add('init');
                                }

                                if (td.getAttribute('date') === endDate.toLocaleString('it-IT', {
                                    month: 'long',
                                    year: 'numeric'
                                })) {
                                    td.classList.add('end');
                                }

                                const flag = document.createElement('span');
                                flag.style.borderColor = notice.color;

                                const clonedPopUp = $popUp.cloneNode(true) as HTMLElement;
                                clonedPopUp.classList.remove('d-none');
                                const $popUpTitleStartDate = clonedPopUp.querySelector('.date.start .date-title') as HTMLElement;
                                const $popUpStartDate = clonedPopUp.querySelector('.date.start .date-content') as HTMLElement;
                                const $popUpTitleEndDate = clonedPopUp.querySelector('.date.end .date-title') as HTMLElement;
                                const $popUpEndDate = clonedPopUp.querySelector('.date.end .date-content') as HTMLElement;
                                $popUpTitleStartDate.innerHTML = `${$popUp.getAttribute('data-start-label')}`;
                                $popUpStartDate.innerHTML = startDate.toLocaleDateString('it-IT', {
                                    day: 'numeric',
                                    month: 'long',
                                    year: 'numeric'
                                });
                                $popUpTitleEndDate.innerHTML = `${$popUp.getAttribute('data-end-label')}`;
                                $popUpEndDate.innerHTML = endDate.toLocaleDateString('it-IT', {
                                    day: 'numeric',
                                    month: 'long',
                                    year: 'numeric'
                                });

                                td.appendChild(flag);
                                td.appendChild(clonedPopUp);
                            }

                            tr.appendChild(td);
                        })

                        $tableBody.appendChild(tr);
                        const activeRows = $tableBody.querySelectorAll('tr');
                        if(activeRows.length) {
                            activeRows.forEach((row) => {
                                const activeRow = row.querySelector('.init span') as HTMLElement;
                                const activeLast = row.querySelector('.end span') as HTMLElement;
                                if(activeRow && !activeRow.classList.contains('start') && !activeRow.classList.contains('middle') && !activeRow.classList.contains('end')) {
                                    if (startDate.getDate() >= 1 && startDate.getDate() <= 10) {
                                        activeRow.classList.add('start');
                                    } else if (startDate.getDate() >= 11 && startDate.getDate() <= 20) {
                                        activeRow.classList.add('middle');
                                    } else if (startDate.getDate() > 20 && startDate.getDate() <= 31) {
                                        activeRow.classList.add('end');
                                    }
                                }

                                if(activeLast && !activeLast.classList.contains('start') && !activeLast.classList.contains('middle') && !activeLast.classList.contains('end')) {
                                    if(endDate.getDate() >= 1 && endDate.getDate() <= 10) {
                                        activeLast.classList.add('start');
                                    } else if(endDate.getDate() >= 11 && endDate.getDate() <= 20) {
                                        activeLast.classList.add('middle');
                                    } else if(endDate.getDate() > 20 && endDate.getDate() <= 31) {
                                        activeLast.classList.add('end');
                                    }
                                }
                            })
                        }
                    });
                }

                function goPrevMonths() {
                    $btnPrev.addEventListener('click', () => {
                        if(window.innerWidth <= 768) {
                            monthOffset -= 3;
                            $btnNext.removeAttribute('disabled');

                            if(monthOffset === -6) {
                                $btnPrev.setAttribute('disabled', '');
                            }
                            updateCalendar();
                        } else {
                            if(monthOffset > -6) {
                                monthOffset -= 6;
                                $btnNext.removeAttribute('disabled');
                                $btnPrev.setAttribute('disabled', '');
                            }
                            updateCalendar();
                        }
                    });
                }

                function goNextMonths() {
                    $btnNext.addEventListener('click', () => {
                        if(window.innerWidth <= 768) {
                            monthOffset += 3;
                            $btnPrev.removeAttribute('disabled');

                            if(monthOffset === 3) {
                                $btnNext.setAttribute('disabled', '');
                            }
                            updateCalendar();
                        } else {
                            if(monthOffset < 6) {
                                monthOffset += 6;
                                $btnNext.setAttribute('disabled', '');
                                $btnPrev.removeAttribute('disabled');
                            }
                            updateCalendar();
                        }
                    });
                }

                updateCalendar();
                goPrevMonths();
                goNextMonths();

                mediaQuery.addEventListener('change', () => {
                    updateCalendar();
                });
            }
        });
    }
}

